export function hasAuthTokens(): boolean {
  const idToken = localStorage.getItem('idToken');
  const authToken = localStorage.getItem('authToken');
  return !!(idToken?.trim() && authToken?.trim());
}
